import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
    PageContent: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '1rem',
    },
    PageContentHeader: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '1rem',
    },
    PageContentHeaderLeft: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '1rem',
    },
    PageContentHeaderRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '1rem',
    },
    PageContentBody: {
        width: '100%',
    },
    PageContentHeaderMenu: {},
    PageContentHeaderMenuContent: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'column',
        gap: '1rem',
    },
}))
